/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * CR022 Autodesk Vault - CAD Download Basket
 *
 *==================================================
 */
//Standard libraries
import { createReducer, AnyAction } from "@reduxjs/toolkit";
//Redux
import initStates from "./initStates";
import { CadBasketReducerState } from "./reducerStateInterface";
import {
  CAD_BASKET_GET_REQUESTED_ACTION,
  CAD_BASKET_GET_SUCCESS_ACTION,
  CAD_BASKET_GET_ERROR_ACTION,
  CAD_BASKET_ZIP_SUCCESS_ACTION,
  CAD_BASKET_ZIP_MESSAGE_RESET_ACTION,
  CAD_BASKET_RESET_ACTION,
  CAD_PDP_EXCLUSION_TOGGLE_ACTION,
  CAD_PDP_EXCLUSIONS_RESET_ACTION,
} from "../actions/cadBasket";

/**
 * cadBasketReducer reducer
 */
const cadBasketReducer = createReducer(initStates.cadBasket, (builder) => {

  builder.addCase(
    CAD_BASKET_GET_REQUESTED_ACTION,
    (state: CadBasketReducerState | any, action: AnyAction) => {
      state.isLoading = true;
    }
  );

  builder.addCase(
    CAD_BASKET_GET_SUCCESS_ACTION,
    (state: CadBasketReducerState | any, action: AnyAction) => {
      state.basketId = action.payload?.basketId ?? null;
      state.items = action.payload?.items ?? [];
      state.isLoading = false;
    }
  );

  builder.addCase(
    CAD_BASKET_GET_ERROR_ACTION,
    (state: CadBasketReducerState | any, action: AnyAction) => {
      state.isLoading = false;
    }
  );

  builder.addCase(
    CAD_BASKET_ZIP_SUCCESS_ACTION,
    (state: CadBasketReducerState | any, action: AnyAction) => {
      state.zipRequested = true;
    }
  );

  builder.addCase(
    CAD_BASKET_ZIP_MESSAGE_RESET_ACTION,
    (state: CadBasketReducerState | any, action: AnyAction) => {
      state.zipRequested = false;
    }
  );

  builder.addCase(
    CAD_BASKET_RESET_ACTION,
    (state: CadBasketReducerState | any, action: AnyAction) => {
      state.basketId = null;
      state.items = [];
      state.isLoading = false;
      state.zipRequested = false;
      state.pdpExclusions = { partNumber: null, ids: [] };
    }
  );

  /** PDP-transient selection of the CAD files to exclude from the ZIP request:
   *  toggled on the Attachments tab before the material is added to the basket */
  builder.addCase(
    CAD_PDP_EXCLUSION_TOGGLE_ACTION,
    (state: CadBasketReducerState | any, action: AnyAction) => {
      const { partNumber, attachmentAssetId } = action.payload;
      const id = String(attachmentAssetId);
      if (state.pdpExclusions.partNumber !== partNumber) {
        state.pdpExclusions = { partNumber: partNumber, ids: [id] };
      } else if (state.pdpExclusions.ids.includes(id)) {
        state.pdpExclusions.ids = state.pdpExclusions.ids.filter((i: string) => i !== id);
      } else {
        state.pdpExclusions.ids.push(id);
      }
    }
  );

  builder.addCase(
    CAD_PDP_EXCLUSIONS_RESET_ACTION,
    (state: CadBasketReducerState | any, action: AnyAction) => {
      state.pdpExclusions = { partNumber: null, ids: [] };
    }
  );

});
export default cadBasketReducer;
